import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useWritePromptResponsePost = () => {
  const createConstructedResponseAnswerPostRequest = useCallback((payload) => {
    const {
      articleId,
      classroomId,
      dateCompleted,
      id,
      promptId,
      text,
      assignmentIds,
    } = payload;

    const body = {
      ...(dateCompleted && { date_completed: dateCompleted }),
      ...(id && { id }),
      article_id: articleId,
      classroom_id: classroomId,
      prompt_content_id: promptId,
      assignment_ids: assignmentIds,
      text,
    };

    const idPath = body.id ? `${id}/` : "";
    const requestUrl = `${MONOLITH_ORIGIN}/api/v2/constructedresponseanswer/${idPath}`;

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createConstructedResponseAnswerPostRequest);
};

export default useWritePromptResponsePost;
